var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidBroker3Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3556 7.31445L16.2298 18.6497C16.1788 18.7892 16.0895 18.9116 15.9722 19.0028C15.8549 19.094 15.7142 19.1503 15.5664 19.1653V19.1707H19.9278C20.2692 19.1707 20.5616 18.9536 20.6703 18.65L24.7975 7.31445H20.3556Z",
    fill: "#A2A2A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5143 11.2773H14.9237V11.2788C14.767 11.2851 14.6156 11.3379 14.489 11.4305C14.3624 11.5231 14.2661 11.6513 14.2126 11.7988L10.0865 23.1336H5.64453L9.7703 11.7984C9.88051 11.4934 10.1728 11.2773 10.5143 11.2773Z",
    fill: "#A2A2A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5678 18.6826C15.4323 18.873 15.2108 18.9987 14.9579 18.9987C14.8119 18.9987 14.6692 18.9559 14.5473 18.8756C14.4254 18.7953 14.3298 18.6811 14.2721 18.5471L13.3828 16.108L14.8961 11.9497C14.9214 11.8746 14.9803 11.786 14.9947 11.7662C15.072 11.6574 15.1769 11.5713 15.2986 11.5167C15.4203 11.4621 15.5543 11.441 15.6869 11.4557C15.8195 11.4704 15.9457 11.5202 16.0526 11.6001C16.1594 11.68 16.2429 11.787 16.2945 11.91L17.1798 14.3393L15.6665 18.499C15.6318 18.5924 15.5824 18.662 15.5678 18.6826Z",
    fill: "#A2A2A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidBroker3Icon);
export default __webpack_public_path__ + "static/media/bfid-broker-3-icon.db75f2a970567a3a18fedcef585e61d4.svg";
export { ForwardRef as ReactComponent };